module.exports = __webpack_public_path__ + "static/media/badge-bg.199d2ec5.png";